<template>
  <el-pagination
    @size-change="handleSizeChange"
    @current-change="handleCurrentChange"
    :current-page="currentPage1"
    layout="prev, pager, next,jumper"
    :page-count="pages">
  </el-pagination>
</template>

<script>
  export default {
    name: "Pagination",
    /**
     * 总页数
     * */
    props:["pages"],
    data(){
      return{
        //  分页功能
        currentPage1: 1,
        currentPage2: 5,
        currentPage3: 5,
        currentPage4: 4,
        pageSize:10,
      }
    },
    methods:{
      //  分页
      handleSizeChange(val) {
      },
      handleCurrentChange(val) {

        // 将数据抛出给父组件
        this.$emit('paginationSearch',val)

        //   分页： 当前页   每页条数
      },
      //  分页结束
    },
  }
</script>

<style scoped>
.el-pagination{
  margin-top: 10px;
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Pagination.vue